import { blue } from 'theme/colors';
import { Box } from '@mui/material';
import { IconCircleCheck, IconCirclePlus, IconMailForward, IconXboxX } from '@tabler/icons-react';
import { ActionButton } from '@atoms';
import { PERMISSIONS } from '@globalConstants';
import { usePermissions } from '@hooks';
import { User } from '@modules/usersManagment/data/useGetAllUsersPaginated';
import { SelectedUserManagement } from '../../data/useApproveUser/hooks/useApproveUser';

/**
 * Buttons on action column on users table
 * @param callback function to trigger on button click
 */
export default function ActionButtons({
  user,
  callback,
}: {
  user: User;
  callback: (u: SelectedUserManagement) => void;
}) {
  const canApprove = usePermissions([PERMISSIONS.WAUsersApprove]);
  const canConfirm = usePermissions([PERMISSIONS.WAUsersConfirm]);
  const canResendEmail = usePermissions([PERMISSIONS.WAUsersEmail]);

  const showApproveRejectActions = user.status === 'PENDING' && canApprove;
  const showCreateAction = user.status === 'APPROVED' && canConfirm;
  const showResendAction = user.status === 'CREATED' && !user.firstTimeLogin && canResendEmail;
  return (
    <Box display={'flex'} justifyContent={'space-around'}>
      <ActionButton
        {...{
          tooltip: 'COMMON:APPROVE',
          icon: <IconCircleCheck color={blue.main} />,
          callback: () => callback({ ...user, action: 'APPROVE' }),
          show: showApproveRejectActions,
        }}
      />
      <ActionButton
        {...{
          tooltip: 'COMMON:REJECT',
          icon: <IconXboxX color={blue.main} />,
          callback: () => callback({ ...user, action: 'REJECT' }),
          show: showApproveRejectActions,
        }}
      />
      <ActionButton
        {...{
          tooltip: 'USERS_MANAGEMENT:ACTIONS:CREATE',
          icon: <IconCirclePlus color={blue.main} />,
          callback: () => callback({ ...user, action: 'CREATE' }),
          show: showCreateAction,
        }}
      />
      <ActionButton
        {...{
          tooltip: 'USERS_MANAGEMENT:ACTIONS:RESEND_EMAIL',
          icon: <IconMailForward color={blue.main} />,
          callback: () => callback({ ...user, action: 'RESEND' }),
          show: showResendAction,
        }}
      />
    </Box>
  );
}
